import env from '../../env';
import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

const jwtHeaders = () => ({
  jwt: localStorage.getItem('microsoftJWT'),
  Accept: 'application/json',
  'Content-Type': 'application/json',
});

export const getDashboardAccepted = createAsyncThunk(
  'dashboard/getDashboardAccepted',
  async (arg, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${env.API_URL_PREFIX}/stats/accepted/allowed`, {
        headers: jwtHeaders(),
      });
      return data;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  }
);

export const getDashboardArrived = createAsyncThunk(
  'dashboard/getDashboardArrived',
  async (arg, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${env.API_URL_PREFIX}/stats/shipped/allowed`, {
        headers: jwtHeaders(),
      });
      return data;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  }
);

export const getDashboardTesting = createAsyncThunk(
  'dashboard/getDashboardTesting',
  async (arg, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${env.API_URL_PREFIX}/stats/testing/allowed`, {
        headers: jwtHeaders(),
      });
      return data;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  }
);

export const getDashboardClarification = createAsyncThunk(
  'dashboard/getDashboardClarification',
  async (arg, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${env.API_URL_PREFIX}/wapi/rmas?filters[clarificationText][$notNull]=true&populate[debitor][fields][0]=customerCode&populate[debitor][fields][1]=id&populate[articles][fields][0]=id&pagination[pageSize]=10000`,
        { headers: jwtHeaders() }
      );
      return data;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  }
);
